import { useNavigate, useParams } from "react-router-dom";
//redux
import { bindActionCreators } from "redux";
import { connect } from "react-redux";
import {
  OfflineCoreServices,
  CallCoreServicesActionWithToken,
} from "../../../appRedux/actions/CoreServicesAction";
import Url from "../../../apiCall/UrlConfig";
import { useEffect, useState } from "react";
import {
  Button,
  Checkbox,
  Divider,
  InputNumber,
  Radio,
  Tag,
  message,
} from "antd";
import { toEnglishDigits } from "../../../component/utility";
const ImagePreAddress = Url.baseURL[0] + Url.downloadImage;
const AnalysesOpg = (props) => {
  let navigate = useNavigate();
  const { id } = useParams();
  const [opgPhoto, setOpgPhoto] = useState(null);
  const [maxillaPhoto, setMaxillaPhoto] = useState(null);
  const [mandiblePhoto, setMandiblePhoto] = useState(null);
  const [AllPhoto, setAllPhoto] = useState(null);
  const [listTeethMaxilla, setListTeethMaxilla] = useState([
    { label: "8L", value: "8L", checked: true },
    { label: "7L", value: "7L", checked: true },
    { label: "6L", value: "6L", checked: true },
    { label: "5L", value: "5L", checked: true },
    { label: "4L", value: "4L", checked: true },
    { label: "3L", value: "3L", checked: true },
    { label: "2L", value: "2L", checked: true },
    { label: "1L", value: "1L", checked: true },

    { label: "1R", value: "1R", checked: true },
    { label: "2R", value: "2R", checked: true },
    { label: "3R", value: "3R", checked: true },
    { label: "4R", value: "4R", checked: true },
    { label: "5R", value: "5R", checked: true },
    { label: "6R", value: "6R", checked: true },
    { label: "7R", value: "7R", checked: true },
    { label: "8R", value: "8R", checked: true },
  ]);

  const [_age, setAge] = useState(0);
  const [_sex, setSex] = useState(0);
  const Sexoptions = [
    {
      label: "مرد",
      value: 1,
    },
    {
      label: "زن",
      value: 2,
    },
  ];
  const [listTeethMandible, setListTeethMandible] = useState([
    { label: "8L", value: "8L", checked: true },
    { label: "7L", value: "7L", checked: true },
    { label: "6L", value: "6L", checked: true },
    { label: "5L", value: "5L", checked: true },
    { label: "4L", value: "4L", checked: true },
    { label: "3L", value: "3L", checked: true },
    { label: "2L", value: "2L", checked: true },
    { label: "1L", value: "1L", checked: true },

    { label: "1R", value: "1R", checked: true },
    { label: "2R", value: "2R", checked: true },
    { label: "3R", value: "3R", checked: true },
    { label: "4R", value: "4R", checked: true },
    { label: "5R", value: "5R", checked: true },
    { label: "6R", value: "6R", checked: true },
    { label: "7R", value: "7R", checked: true },
    { label: "8R", value: "8R", checked: true },
  ]);

  useEffect(() => {
    GetPatientOPGPhoto();
  }, []);

  const GetPatientOPGPhoto = async () => {
    let url = Url.GetOpgPhoto;

    let res = await props.actions.CallCoreServicesActionWithToken(url, { id });

    console.log(res);
    if (res.hasError) {
      message.error(res.message);
      return;
    }

    if (res.data?.patientImages.length > 0) {
      let maxilla = res.data?.patientImages.find((o) => o.type == "maxilla");
      let mandible = res.data?.patientImages.find((o) => o.type == "mandible");
      let opg = res.data?.patientImages.find((o) => o.type == "opg");
      let all = res.data?.patientImages.find((o) => o.type == "all");
      setMaxillaPhoto(maxilla);
      setMandiblePhoto(mandible);
      setOpgPhoto(opg);
      setAllPhoto(all);
      setAge(res?.data?.age);
      setSex(res?.data?.sex);
    }
  };

  const _onClickTeeth = (label) => {
    let newList = [...listTeethMaxilla];
    let object = newList.find((o) => o.label == label);
    object.checked = !object.checked;
    let index = newList.findIndex((o) => o.label == label);
    newList[index] = object;
    setListTeethMaxilla(newList);
  };

  const _onClickTeethMandible = (label) => {
    let newList = [...listTeethMandible];
    let object = newList.find((o) => o.label == label);
    object.checked = !object.checked;
    let index = newList.findIndex((o) => o.label == label);
    newList[index] = object;
    setListTeethMandible(newList);
  };

  const _saveAnalyses = async () => {
    let data = {
      patientId: opgPhoto.patientId,
      patientImageId: opgPhoto.id,
    };

    let ListMaxila = listTeethMaxilla.map((o) => {
      return {
        jaw: "maxilla",
        numberTeeth: o.label,
        status: o.checked ? "present" : "missed",
      };
    });
    let ListMandible = listTeethMandible.map((o) => {
      return {
        jaw: "mandible",
        numberTeeth: o.label,
        status: o.checked ? "present" : "missed",
      };
    });
    let OpgDetail = [...ListMaxila, ...ListMandible];

    data["opgDetails"] = OpgDetail;

    let url = Url.saveOpgAnalyses;
    let res = await props.actions.CallCoreServicesActionWithToken(url, data);

    console.log(res);
    if (res.hasError) {
      message.error(res.message);
      return;
    }
    message.success(res.message);
    navigate("/opganalyse/mainpage");
  };

  const _saveAge = async () => {
    let url = Url.saveAge;
    let res = await props.actions.CallCoreServicesActionWithToken(url, {
      id: id,
      age: _age,
    });

    console.log(res);
    if (res.hasError) {
      message.error(res.message);
      return;
    }
  };

  const _onChangeSex = async (sex) => {
    setSex(sex);
    let url = Url.saveSex;
    let res = await props.actions.CallCoreServicesActionWithToken(url, {
      id: id,
      sex: sex,
    });

    if (res.hasError) {
      message.error(res.message);
      return;
    }
  };
  return (
    <div dir="ltr">
      <div className="text-center">
        <img
          style={{ width: "100%", maxWidth: 700 }}
          src={ImagePreAddress + AllPhoto?.imageUrl}
        />
      </div>
      <InputNumber
        addonBefore="Age "
        onFocus={(e) => e.target.select()}
        onBlur={_saveAge}
        value={_age}
        onChange={(val) => setAge(val)}
      />
      <Radio.Group
        options={Sexoptions}
        onChange={(e) => _onChangeSex(e.target.value)}
        value={_sex}
      />
      {opgPhoto != null && (
        <div className="text-center">
          <img
            style={{ width: "600px" }}
            src={ImagePreAddress + opgPhoto.imageUrl}
          />
        </div>
      )}

      {_age > 0 && _sex > 0 && (
        <>
          <>
            <div className="text-center">
              <img
                style={{ width: "200px" }}
                src={ImagePreAddress + maxillaPhoto?.imageUrl}
              />
            </div>
            <div dir="ltr" className="text-center">
              {listTeethMaxilla.map((o, index) => {
                return (
                  <>
                    <Tag
                      style={{ cursor: "default" }}
                      className="margin-horizontal"
                      key={o.value}
                      color={o.checked ? "#108ee9" : ""}
                      onClick={() => {
                        _onClickTeeth(o.label);
                      }}
                    >
                      {o.label}
                    </Tag>
                    {index == 7 && <Divider type="vertical" />}
                  </>
                );
              })}
            </div>
          </>
          <>
            <div className="text-center">
              <img
                style={{ width: "200px" }}
                src={ImagePreAddress + mandiblePhoto?.imageUrl}
              />
            </div>
            <div dir="ltr" className="text-center">
              {listTeethMandible.map((o, index) => {
                return (
                  <>
                    <Tag
                      style={{ cursor: "default" }}
                      className="margin-horizontal"
                      key={o.value}
                      color={o.checked ? "#108ee9" : ""}
                      onClick={() => {
                        _onClickTeethMandible(o.label);
                      }}
                    >
                      {o.label}
                    </Tag>
                    {index == 7 && <Divider type="vertical" />}
                  </>
                );
              })}
            </div>
          </>
        </>
      )}
      <Button
        className="text-center"
        loading={props.coreData[Url.saveOpgAnalyses]?.[Url.action]?.isFetching}
        style={{ marginTop: 50 }}
        type="primary"
        onClick={() => _saveAnalyses()}
        disabled={_age <= 0 || _sex <= 0}
      >
        Save Analyses
      </Button>
    </div>
  );
};

const actionCreators = Object.assign(
  {},
  { CallCoreServicesActionWithToken, OfflineCoreServices }
);
const mapDispatchToProps = (dispatch) => ({
  actions: bindActionCreators(actionCreators, dispatch),
});

const mapStateToProps = (state) => ({
  coreData: state.coreservices.coreData,
});

export default connect(mapStateToProps, mapDispatchToProps)(AnalysesOpg);
